<template>
    <title>横浜市問合せフォーム</title>
      <v-container class="px-4" v-if="isShow">
        <v-col>
          <div class="announce-body" v-html="AnnounceBody"></div>
      </v-col>
      <v-col class="text-center">
        <v-btn title="次へ進む" variant="elevated" class="custom-btn" to="/inquiry">
          次へ進む
        </v-btn>
      </v-col>
    </v-container>
</template>

<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';

export default {
  name: 'HomePage',
  setup(){

    let isShow = ref(false);
    let AnnounceTitle = ref('');
    let AnnounceBody = ref('');
    let isAnnounce = ref(false);

    const getAnnouce = async () =>{
      AnnounceTitle.value = "";
      AnnounceBody.value = "";
      try{
        var url = process.env.VUE_APP_ANNOUNCE_API_URL;
        var res = await axios.get(url);
        console.log(url,":", res);
        if(res.status == 200){
          AnnounceTitle.value = res.data.announceTitle;
          AnnounceBody.value = res.data.announceBody;
        }
        isAnnounce.value = AnnounceTitle.value != "" && AnnounceBody.value != "";
        isShow.value = true;
      } catch (error) {
        console.log("annouce data error:", error);
      }
    }

    onMounted(async () => {
      await getAnnouce();
      isShow.value = true;
    });

    return{
      isShow,
      isAnnounce,
      AnnounceTitle,
      AnnounceBody
    }
  },
}
</script>
<style>
.announce-body h2 {
  color: rgb(38, 90, 185);
  font-size: 1.2em;
  font-weight: bold;
}

.announce-body hr {
  margin-top: 20pt;
  margin-bottom: 20pt;
}

.announce-body .word-wrap {
  word-wrap: break-word;
  /* 旧ブラウザ向け */
  overflow-wrap: break-word;
  /* モダンブラウザ向け */
}
</style>

<style scoped>

header
{
  padding: 0 !important;
}

.custom-btn {
  background-color: #0071BD;
  color: white;
  border: 1px solid rgb(1, 11, 163);
  border-radius: 6px;
  cursor: pointer;
  vertical-align:middle;
  transition: background-color 0.3s ease;
}

.custom-btn:hover {
  border-color: #003366; /* ダークブルーの枠 */
  background-color: #9fa6c8; /* ホバー時の背景色 */
}
</style>